import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Icon button with tooltip
 * @param {Object} props
 * @param {React.ReactNode} props.icon - Icon component
 * @param {string} props.tooltip - Tooltip text
 * @param {string} props.variant - Bootstrap variant
 * @param {Function} props.onClick - Click handler
 * @param {string} [props.className] - Additional classes
 */
function IconButton({
  icon,
  tooltip,
  variant = 'primary',
  onClick,
  className = '',
}) {
  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
      <button
        className={`btn btn-${variant} btn-sm ${className} btn-icon animate__animated animate__pulse animate__faster`}
        onClick={onClick}
      >
        {icon}
      </button>
    </OverlayTrigger>
  );
}

IconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  tooltip: PropTypes.string.isRequired,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
  ]),
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default IconButton;